var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrganicFood = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Organic-Plant--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Organic Plant Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.4a10 10 0 0 1 -1.4 -1.11 1 1 0 0 0 -1.38 1.44 11.35 11.35 0 0 0 1.68 1.34 1 1 0 0 0 1.39 -0.28 1 1 0 0 0 -0.29 -1.39Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42 17.19a9.56 9.56 0 0 1 -0.78 -1.61A1 1 0 0 0 1.35 15a1 1 0 0 0 -0.58 1.29 11.48 11.48 0 0 0 0.94 1.93 1 1 0 1 0 1.71 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.09 21.56a9.35 9.35 0 0 1 -1.74 0.4 1 1 0 1 0 0.26 2 11.62 11.62 0 0 0 2.1 -0.48 1 1 0 1 0 -0.62 -1.9Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.66 22a9.35 9.35 0 0 1 -1.74 -0.4 1 1 0 0 0 -0.62 1.91 11.6 11.6 0 0 0 2.1 0.47 1 1 0 0 0 0.26 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.65 15a1 1 0 0 0 -1.29 0.58 10 10 0 0 1 -0.78 1.62 1 1 0 1 0 1.72 1 11.43 11.43 0 0 0 0.93 -1.93 1 1 0 0 0 -0.58 -1.27Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.91 19.28a11.45 11.45 0 0 1 -1.4 1.12 1 1 0 0 0 -0.29 1.38 1 1 0 0 0 1.39 0.29 13.52 13.52 0 0 0 1.68 -1.34 1 1 0 0 0 0 -1.42 1 1 0 0 0 -1.38 -0.03Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.05a12 12 0 0 0 -12 12c0 0.37 0 0.73 0.05 1.09a1 1 0 0 0 1.09 0.9A1 1 0 0 0 2 13a9.1 9.1 0 0 1 0 -0.91 10 10 0 0 1 20 0 9.1 9.1 0 0 1 0 0.91 1 1 0 0 0 2 0.18c0 -0.36 0.05 -0.72 0.05 -1.09A12 12 0 0 0 12 0.05Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10.76a8.05 8.05 0 0 0 5.71 7.69 0.22 0.22 0 0 0 0.22 0 0.23 0.23 0 0 0 0.1 -0.2 9.77 9.77 0 0 1 1 -4.14 0.51 0.51 0 0 0 0 -0.52 8.06 8.06 0 0 0 -6.49 -3.29 0.5 0.5 0 0 0 -0.54 0.46Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.81 12.22a0.25 0.25 0 0 0 0.38 0 9.73 9.73 0 0 1 2.46 -2.11 0.52 0.52 0 0 0 0.25 -0.48 8.87 8.87 0 0 0 -2.55 -5.44 0.5 0.5 0 0 0 -0.7 0A8.9 8.9 0 0 0 9.1 9.63a0.51 0.51 0 0 0 0.24 0.48 9.61 9.61 0 0 1 2.47 2.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.05v-0.88a0.5 0.5 0 0 1 0.41 -0.5A8 8 0 0 0 20 10.76a0.5 0.5 0 0 0 -0.5 -0.5 8.06 8.06 0 0 0 -8 7.79v2a0.75 0.75 0 0 0 1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrganicFood);
export default ForwardRef;